import { render, staticRenderFns } from "./PlantImageView.vue?vue&type=template&id=581099ee&scoped=true"
import script from "./PlantImageView.vue?vue&type=script&lang=ts"
export * from "./PlantImageView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581099ee",
  null
  
)

export default component.exports